<template>
  <section>
      <header class="flex">
      <h3  class="title">TESTIMONIALS</h3>
      <h1>What our members  <br> have to say.</h1>
      <img src="../../assets/underline.png" alt="">
      </header>

  <div class="flex1">

<div class="left-container">
      <div class="testi">
          <div class="child">
              <img class="overlay" src="../../assets/testi.png" alt="">
<h3>Joseph D’sa <br>
Parent</h3>
<br>
<h4>We offer transformative online and offline yoga <br> classes for kids, aged three to fifteen. We focus <br> on the mind-body connect and making sure <br> that both girls and boys are developing <br> holistically</h4>
      </div>
      
      <!-- <div class="comma"> <img src="../../assets/comma2.png" alt=""></div> -->
      </div>
      </div>

<div class="right-container">
      <div class="testi">
           <div class="child">
               <img class="overlay" src="../../assets/testi.png" alt="">
<h3>Joseph D’sa <br>
Parent</h3>
<br>
<h4>We offer transformative online and offline yoga <br> classes for kids, aged three to fifteen. We focus <br> on the mind-body connect and making sure <br> that both girls and boys are developing <br> holistically</h4>
      </div>
      
       <!-- <div class="comma"> <img src="../../assets/comma2.png" alt=""></div> -->
      </div>
      </div>


      

</div>


     <div class="radio-button">
           <input type="radio" name="fav_language" checked value="HTML"><br>
  <input type="radio" name="fav_language" value="CSS"><br>
  <input type="radio" name="fav_language" value="JavaScript"><br>
  <input type="radio" name="fav_language" value="JavaScript"><br>
      </div>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.left-container,.right-container{
    margin-top: 17px;
}

   input[type='radio']:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: #60993E;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 2px solid #60993E;
    }

   input[type='radio']:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: white;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 2px solid #60993E;
    }

.radio-button{
    display: flex;
    width: 97px;
    margin: auto;
    align-items: center;
    justify-content: space-evenly;
    padding-top: 78px;
}

.comma{
        margin-left: 375px;
    margin-top: 24px;
}
.title{
     color: #791E94;
    font-weight: 450;
}
.child{
        display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-end;
        padding-left: 46px;
    padding-top: 46px;
}
h4{
    color: #445268;
    font-weight: 500;
    line-height: 200%;
}
.flex1{
    display: flex;
    width: 80%;
    margin: auto;
    justify-content: space-around;
    padding-top: 149px;
    flex-wrap: wrap;
}
.overlay{
    position: relative;
    top: -82px;
    left: -94px;
}
.flex{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    height: 316px;
    text-align: center;
    margin-top: 150px;
    
    
}
.testi{
    background: #F9F9D2;
border-radius: 20px;
/* transform: rotate(90deg); */
   width: 504px;
   height: 400px;
}
h3{
    color: #44526B;
    font-weight: 800;
}
h1{
     font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: #791E94;
}

@media (max-width: 1080px){
    .child{
        padding: 30px;
    }
    .overlay{
        position: relative;
    top: -34px;
    left: -51px;
    }
    .testi{
           max-width: 289px;
    min-height: 512px;
    }
}
</style>